import { Link } from "react-router-dom";
import React, { useState } from "react";
import "./HomeLoveYourScreen.css";
import ViewAllLink from "../../components/ViewAllLink";
import { useCurrency } from "../../Context/CurrencyContext";

function HomeLoveYourScreen() {

  const { formatPrice } = useCurrency();
  const [active, setActive] = useState(null);

  const hotspots = [
    {
      id: 1,
      y: 0.18,
      x: 0.48,
      type: "benefit",
      icon: "plus",
      card: {
        title: "Smooth Forehead Care",
        image:
          "https://wonder-theme-beauty.myshopify.com/cdn/shop/files/insta-2.jpg?v=1756140020&width=300",
        text:
          "Gentle cleansing helps refresh your skin and reduce the appearance of fine lines.",
      },
    },

    {
      id: 2,
      y: 0.42,
      x: 0.42,
      type: "benefit",
      icon: "plus",
      card: {
        title: "Radiant Cheek Care",
        image:
          "https://wonder-theme-beauty.myshopify.com/cdn/shop/files/mokosh-butelka-12_9aee4959-19ad-4899-8628-412d2818893a.jpg?v=1727383516&width=600",
        text:
          "Daily hydration keeps your cheeks soft, plump, and glowing.",
      },
    },

    {
      id: 3,
      y: 0.45,
      x: 0.60,
      type: "product",
      icon: "dot",
      product: {
        brand: "BKIND",
        title: "Algae Peel-Off Mask",
        price: 10700,
        priceValue: 10700,
        image:
          "https://wonder-theme-beauty.myshopify.com/cdn/shop/products/bkind-floral-face-2_718634ed-72d4-47b3-98aa-ab26bbc66519.jpg?v=1661113363&width=300",
        link: "/products/algae-peel-off-mask-with-soothing-properties",
      },
    },

    {
      id: 4,
      y: 0.84,
      x: 0.32,
      type: "product",
      icon: "dot",
      product: {
        brand: "MOKOSH",
        title: "Body balm Melon & cucumber",
        price: 1600,
        priceValue: 1600,
        image:
          "https://wonder-theme-beauty.myshopify.com/cdn/shop/products/mokosh_body_balm.jpg?v=1655661409&width=300",
        link: "#",
      },
      position: "top",
    },
  ];

  const renderIcon = (spot) => {
    if (spot.icon === "dot") {
      return (
        <svg width="18" height="18" viewBox="0 0 20 20">
          <path
            d="M10 4 A6 6 0 1 1 9.999 4 Z"
            fill="none"                 // 👈 changed from "#ffffff" to "none"
            stroke="#000"
            strokeWidth="2"
          />
        </svg>
      );
    }

    return (
      <svg
        className="svg-icon svg-icon--plus-eleven"
        xmlns="http://www.w3.org/2000/svg"
        width="72"
        height="72"
        viewBox="0 0 72 72"
      >
        <g>
          <rect
            className={`icon-plus-y-eleven ${
              active === spot.id ? "rotate-45" : ""
            }`}
            width="54"
            height="4"
            rx="2"
            y="34"
            x="9"
          />
          <rect
            className={`icon-plus-x-eleven ${
              active === spot.id ? "opacity-0" : ""
            }`}
            width="4"
            height="54"
            rx="2"
            y="9"
            x="34"
          />
        </g>
      </svg>
    );
  };

  return (
    <section className="love-wrapper-eleven">

      <h2 className="love-heading-eleven">Love Your Skin</h2>

      <div className="image-box-eleven">
        <div className="image-wrapper-eleven">

          <img
            src="/assets/loveyourscreen.webp"
            alt="Love Your Skin"
            className="love-image-eleven"
          />

          {hotspots.map((spot) => (

            <div
              key={spot.id}
              className={`hotspot-wrapper-eleven ${
                active === spot.id ? "active-eleven" : ""
              }`}
              style={{
                top: `${spot.y * 100}%`,
                left: `${spot.x * 100}%`,
              }}
            >

              <div className="wt-dot-eleven">

                <div
                  className={`wt-dot__ringing-eleven ${
                    active === spot.id ? "ringing-paused" : ""
                  }`}
                ></div>

                <div
                  className="wt-dot__circle-eleven"
                  onClick={() =>
                    setActive(active === spot.id ? null : spot.id)
                  }
                >
                  <span className="wt-dot__icon-eleven">
                    {renderIcon(spot)}
                  </span>
                </div>

                {/* PRODUCT TOOLTIP */}
                {spot.type === "product" && active === spot.id && (
                  <div
                    className={`wt-dot__tooltip-eleven ${
                      spot.position === "top" ? "popup-top-eleven" : ""
                    }`}
                  >
                    <a href={spot.product.link} className="wt-dot__link-eleven">
                      <img
                        src={spot.product.image}
                        alt={spot.product.title}
                        className="wt-dot__image-eleven"
                      />
                      <div className="wt-dot__body-eleven">
                        <div className="wt-dot__brand-eleven">
                          {spot.product.brand}
                        </div>
                        <div className="wt-dot__title-eleven">
                          {spot.product.title}
                        </div>
                        <div className="wt-dot__price-eleven">
                          {formatPrice(spot.product.price)}
                        </div>
                      </div>
                    </a>
                  </div>
                )}

                {/* BENEFIT TOOLTIP */}
                {spot.type === "benefit" && active === spot.id && (
                  <div className="wt-dot__tooltip wt-dot__tooltip--active" style={{ display: 'initial' }}>
                    <div className="wt-dot__link wt-dot__link--benefit" tabIndex="0">
                      <picture className="wt-dot__picture">
                        <img
                          srcSet={`
                            ${spot.card.image}&width=300 300w,
                            ${spot.card.image}&width=600 600w,
                            ${spot.card.image}&width=900 900w,
                            ${spot.card.image}&width=300 300w
                          `}
                          sizes="(min-width: 900px) 300px, 100vw"
                          src={spot.card.image}
                          alt={spot.card.title}
                          className="wt-dot__image"
                          width="1024"
                          height="1024"
                          loading="lazy"
                        />
                      </picture>
                      <div className="wt-dot__body">
                        <h3>{spot.card.title}</h3>
                        <div className="wt-dot__text rte">
                          <p>{spot.card.text}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              </div>

            </div>

          ))}

        </div>
      </div>

      <div className="view-all-bar-eleven">

        <Link to="/daily-routine" className="view-products-eleven">

          <ViewAllLink />

          <span className="product-text-wrapper">
            <span className="product-text">PRODUCTS</span>
            <span className="product-underline"></span>
          </span>

        </Link>

      </div>

    </section>
  );
}

export default HomeLoveYourScreen;